/**
 * Базовый URL central, куда уходят заявки с лендинга.
 * Значение вшивается при сборке (CRA), поэтому задаётся на этапе docker build:
 * REACT_APP_CENTRAL_API_URL=https://central.beheard.kz
 */
export const CENTRAL_API_URL = (process.env.REACT_APP_CENTRAL_API_URL || '').replace(/\/$/, '');

export const LEAD_ENDPOINT = `${CENTRAL_API_URL}/api/public/lead`;
